import React, { useState } from 'react'
import { useDebounce } from 'use-debounce'
import { ControllerRenderProps, ControllerFieldState, UseFormStateReturn } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import CircularProgress from '@mui/material/CircularProgress'
import { OrganizationScope } from 'store/store.types'
import { useListRegionsQuery } from 'store/regions/regions.api'

export type FormRegionAutocompleteProperties = {
  field: ControllerRenderProps<any, string>
  fieldState: ControllerFieldState
  formState: UseFormStateReturn<any>
}

export default function FormRegionAutocomplete(props: FormRegionAutocompleteProperties) {
  const { field, fieldState } = props
  const { onChange, ...rest } = field
  const [_search, _setSearch] = useState<string>('')
  const [search] = useDebounce(_search, 400)
  const { organizationId } = useParams<OrganizationScope>()
  const { data = { data: [] }, isLoading } = useListRegionsQuery({ organizationId, search })
  const options = React.useMemo(() => {
    return data?.data?.map((region) => ({ name: region.attributes.name, value: region.id })) || []
  }, [data?.data])

  return (
    <Autocomplete
      {...rest}
      fullWidth
      sx={{ marginBottom: 3 }}
      options={options}
      value={field.value || null}
      getOptionLabel={(option) => option?.name || ''}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      loading={isLoading}
      onChange={(event, option) => {
        onChange(option)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Region"
          variant="outlined"
          required
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
              </React.Fragment>
            ),
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
          onChange={(event) => _setSearch(event.target.value)}
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message}
        />
      )}
    />
  )
}
